import { render } from "./Login.vue?vue&type=template&id=5c6f0a2c"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script